import { JUTRO_TOPICS } from '@jutro/events';
export let HttpEventTypes;
(function (HttpEventTypes) {
  HttpEventTypes["request"] = "request";
  HttpEventTypes["response"] = "response";
  HttpEventTypes["error"] = "error";
  HttpEventTypes["exception"] = "exception";
})(HttpEventTypes || (HttpEventTypes = {}));
export const eventTopicMap = {
  [HttpEventTypes.request]: JUTRO_TOPICS.FETCH_REQUEST,
  [HttpEventTypes.response]: JUTRO_TOPICS.FETCH_RESPONSE,
  [HttpEventTypes.error]: JUTRO_TOPICS.FETCH_ERROR,
  [HttpEventTypes.exception]: JUTRO_TOPICS.FETCH_ERROR
};
export const JSON_CONTENT_TYPE = 'application/json';
export const BLOB_CONTENT_TYPE = 'application/octet-stream';
export const CONTENT_TYPE = 'Content-Type';